import { useContext, useEffect, useState } from "react";
import { GroupOwnerContext } from "../contexts";
import { EnrollerType } from "../types/groupOwner.types";

const useAgent = (): { agentId: string | null; isEnroller: boolean | null; enrollerType: EnrollerType | null } => {
	const { groupOwner } = useContext(GroupOwnerContext);
	const [agentId, setAgentId] = useState<string | null>(null);
	const [isEnroller, setIsEnroller] = useState<null | boolean>(null);
	const [enrollerType, setEnrollerType] = useState<null | EnrollerType>(null);
	// console.log("G: Group Owner", groupOwner);
	useEffect(() => {
		if (groupOwner) {
			setAgentId(groupOwner._id);
			const { role, type } = groupOwner;
			if (role === "EMPLOYER" && ["ENROLLER ADMIN", "AGENT"].includes(type)) {
				setIsEnroller(true);
				setEnrollerType(type);
			} else {
				setIsEnroller(false);
			}
		} else {
			setIsEnroller(false);
		}
	}, [groupOwner]);

	return {
		agentId,
		isEnroller,
		enrollerType
	};
};

export default useAgent;
